import { ICargo } from "../interfaces";
import swal from "sweetalert";

export const ErrorResponseDialog = (cargo: ICargo, t: any, projectCode?: string) => {
  switch (cargo.returnCode) {
    case '100001':
      swal(t('errorCode.100001'), "", "error");
      break;
    case '100003':
      swal(t('accessTokenExpired'), "", "error").then(() => {
        if (projectCode === 'NFT') {
          window.location.href = "/web/login/nft";
        } else {
          window.location.href = "/login.html";
        }
      });
      break;
    case '100004':
      swal(t('invalidOtp'), "", "error");
      break;
    case '100016':
      swal(t('pleaseCompleteYourProfile'), "", "warning");
      break;
    case '200002':
      swal(t('nftDoesNotExist'), "", "warning");
      break;
    case '500003':
      swal(t('insufficientBalance'), "", "warning");
      break;
    case '600001':
      swal(t('walletError'), "", "warning");
      break;
    case '600002':
      swal(t('transactionLock'), t('waitTenMins'), "warning");
      break;
    default:
      swal(t('error'), cargo.returnCode, "warning");
  }
}